export default __webpack_public_path__ + "static/media/SVerificado.1743bca1.svg";